import React, { useEffect, useState } from 'react';
import { ApiRequest } from 'GlobalFunctions';
import { Checkbox, List, ListItem, ListItemText, Typography, Box, Paper } from '@mui/material';

interface User {
  user_id: string;
  name: string;
  last_name: string;
}

interface UsersListProps {
  onSelectUsers: (userIds: string[]) => void;
}

export default function UsersList({ onSelectUsers }: UsersListProps) {
  const [userList, setUserList] = useState<User[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    // Pass selected users to parent whenever selection changes
    onSelectUsers(selectedUsers);
  }, [selectedUsers, onSelectUsers]);

  const fetchUsers = async () => {
    setLoading(true);
    await ApiRequest({
      url: "/users/listByRole",
      method: "get",
      headers: {
        'ltkn': localStorage.getItem('ltkn')
      },
      query: {
        role_ids: [6,7],
        full_list: true
      },
      setResponse: (response: any) => {
        if (response && response.list) {
          setUserList(response.list);
        }
        setLoading(false);
      }
    });
  };

  const handleToggleUser = (userId: string) => {
    setSelectedUsers(prev => {
      if (prev.includes(userId)) {
        return prev.filter(id => id !== userId);
      } else {
        return [...prev, userId];
      }
    });
  };

  if (loading) {
    return <Box p={2}>Loading users...</Box>;
  }

  return (
    <div id="users_filter" className='filters_section'>
      <h2>Usuarios</h2>
      <div className='filter_list'>
        {userList.length > 0 ? (
          userList.map((user) => (
            <ListItem
              key={user.user_id}
              dense
              button
              onClick={() => handleToggleUser(user.user_id)}
            >
              <Checkbox
                edge="start"
                checked={selectedUsers.includes(user.user_id)}
                tabIndex={-1}
                disableRipple
              />
              <ListItemText primary={`${user.name} ${user.last_name}`} />
            </ListItem>
          ))
        ) : (
          <ListItem>
            <ListItemText primary="No users found" />
          </ListItem>
        )}
      </div>
    </div>
  );
}


